/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The verification result.
 */
export interface CredentialVerify {
    /** Indicates whether the credential is verified. */
    verified: boolean;
}
